/**
 * webview 容器的平台的检测, 优先匹配越后面的
 */
const env = [
  ['qq', /qq/],
  ['weixin', /micromessenger/],
  ['weibo', /weibo/],
  ['knb', /knb/],
  ['daxiang', /XM\/\d{1,2}.\d{1,2}.\d{1,2}/]
];

/**
 * 浏览器以及 webview 的 ua, 这个是详细的匹配
 */
const ua = [];

export {
  ua,
  env
};
